import React from 'react'
import '../assets/styles/modal.scss';
import closeIcon from '../images/icons/Icon2.png';
import { useTranslation } from 'react-i18next';
import useSidebarHidden from '../common/useSidebarHidden.jsx';

export const CessViewModal = (props) => {
  const {name}=props.cessDetails;
  const { t } = useTranslation();
    const sideBarHidden = useSidebarHidden('.content-container');

  const listItems = props.conditions.map((list,index) =>
{
  return(<React.Fragment key={index}>
        <div className='row'>
         <div className='col-xs-11 wrapper' >
     <p>{list.predicate}</p>
        </div>
        </div>
        </React.Fragment>)}
 );
  return (
      <div className="overlay" role="dialog">
       <div className={`${sideBarHidden ? 'dialog-fs2' : 'dialog'} sm-scrollbar`}>
        <div className="dialog__content">
            <div className='dialog-header flexRow alignItemsCenter width100 content-tabs'>
                    <h2 className="dialog__title subheading-text-medium fontMedium justifyContentCenter alignItemsCenter margBottom0 width50">Conditions - {name}</h2>
                        <button className='close-btn-ht' onClick={props.onClose}>
                          <img src={closeIcon} alt="close" data-icon='close'/>
                        </button>
                  </div>
          <hr />
          <div className="dialog__body_container flexRow justifyContentSpaceBetween flexWrap">
            <ul className='list-group'>
                {listItems}
            </ul>
          </div>
        </div>
        <div className="dialog__footer flexRow justifyContentSpaceEvenly">
        <button className={`done-button`} onClick={props.onClose}>{t('buttons.done')}</button>
      </div>
      </div>
      </div>
  );
}
